"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getDateText = function getDateText(date, l) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  var dayaftertomorrow = new Date();
  dayaftertomorrow.setDate(dayaftertomorrow.getDate() + 2);
  dayaftertomorrow.setHours(0, 0, 0, 0);
  if (date.getTime() === today.getTime()) {
    return l("reactWeather.today");
  } else if (date.getTime() === tomorrow.getTime()) {
    return l("reactWeather.tomorrow");
  } else if (date.getTime() === dayaftertomorrow.getTime()) {
    return l("reactWeather.theDayAfterTomorrow");
  } else {
    return [date.getDay()];
  }
};
var _default = getDateText;
exports.default = _default;